import './localization.js'

const Swal = require('sweetalert2');

/**
 * Notification for front pages
 * Allow type: success | info | warning | error
 * @param text
 * @param type
 */

window.notify = function (text, type = 'success') {
    Swal.close();
    Swal.fire({
        position: 'top-end',
        icon: type,
        title: text,
        showConfirmButton: false,
        showCloseButton: true,
        timer: 3500,
        timerProgressBar: true,
        toast: true,
    })
}


function openModalCartAfterReload() {
    let showModel = null
    let togglemodal = JSON.parse(localStorage.getItem('open'))

    if ($('#modal-cart').hasClass('show')) {
        showModel = true
        localStorage.setItem('open', JSON.stringify(showModel));
    } else {
        showModel = false
        localStorage.removeItem('open')
        localStorage.setItem('open', JSON.stringify(showModel));
    }
    togglemodal === true && $('#modal-cart').modal('show')
}

function getCounties() {
    $.ajax({
        type: "GET",
        url: '/countries',
        success: function (response) {
            if (response.data) {
                response.data.forEach(countryOption => {
                    let country = `<option value="${countryOption.code}">${countryOption.name}</option>`
                    $('body .js-select-country-code').append(country)
                })
                localStorage.setItem('countries', JSON.stringify(response.data))
            }
        },
    });
}

let countries = JSON.parse(localStorage.getItem('countries'))
countries == null && getCounties()

countries != null && $(countries).each((index, item) => {
    let country = `<option value="${item.code}">${item.name}</option>`
    $('body .js-select-country-code').append(country)

})

$('.show-after-click').on('click', e => {
    localStorage.setItem('clientModel', JSON.stringify($(e.target).attr('data-link')))
})

let myLink = JSON.parse(localStorage.getItem('clientModel'))

$('body').on('click', ' .js-redirect', e => {
    window.location.reload(myLink);
})

$('body').on('click', '.js-dropdown', e => {
    if($(e.target).siblings('.dropdown-menu').hasClass('active')) {
        $(e.target).siblings('.dropdown-menu').removeClass('active')
    } else {
        $('.js-dropdown').siblings('.dropdown-menu').removeClass('active')
        $(e.target).siblings('.dropdown-menu').addClass('active')
    }
})

$('body').on('click', '.js-dropdown-count', e => {
    // if($(e.target).siblings('.dropdown-menu').hasClass('active')) {
    //     $(e.target).siblings('.dropdown-menu').removeClass('active')
    // } else {
    //     $('.js-dropdown').siblings('.dropdown-menu').removeClass('active')
        $(e.target).siblings('.dropdown-menu').toggleClass('active')
    // }
})

$('body').on('change', '[type="file"]', function (e) {
    let file = e.target.files[0].name;
    $(this).next('.label-input-file').html(file);
});

$('.js-open-nav-menu').on('click', e => {
    $('.navbar-collapse').toggleClass('d-none')
})

let iconCounts = document.querySelectorAll('.js-count-items')

iconCounts.forEach(count => {
    count.textContent = localStorage.getItem('itemCount')
})
